import { Box } from '@mui/material'
import { MRT_ColumnDef as MRTColumnDef } from 'material-react-table'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import MRTDataGridv2 from '../../../components/MRTDataGrid/MRTDataGridv2'
import EmbeddedContainer from '../components/EmbeddedContainer'
import { messages } from '../messages'
import { Journey, JourneyLoad } from '../types'
import { getUniqueLegsForLoad, getUniqueRoutesForLoad } from '../utils'


type EmbeddedLoadTableProps = {
    loads: JourneyLoad[]
    journey: Journey
}

const EmbeddedLoadTable = ({ loads, journey }: EmbeddedLoadTableProps) => {
    const { formatMessage } = useIntl()

    const columns = useMemo<MRTColumnDef<JourneyLoad>[]>(() => {
        return [
            {
                accessorFn: (row) => {
                    return `Load ${row.id}`
                },
                header: formatMessage(messages.loadName),
            },
            {
                accessorFn: (row) => {
                    return row.quantity
                },
                header: formatMessage(messages.quantity),
            },
            {
                accessorFn: (row) => {
                    return row.isHazardous ? 'Yes' : 'No'
                },
                header: formatMessage(messages.isHazardous),
            },
            {
                accessorFn: (row) => {
                    const routes = getUniqueRoutesForLoad(journey, row.id)
                    return routes.reduce((acc, item) => {
                        if (acc === '') {
                            return `Route ${item.id}`
                        }
                        return acc + ` / Route ${item.id}`
                    }, '')
                },
                header: formatMessage(messages.routesName)
            },
            {
                accessorFn: (row) => {
                    const legs = getUniqueLegsForLoad(journey, row.id)
                    return legs.reduce((acc, item) => {
                        if (acc === '') {
                            return `Leg ${item.id}`
                        }
                        return acc + ` / Leg ${item.id}`
                    }, '')
                },
                header: formatMessage(messages.legsName)
            },
        ]
    }, [])


    return (
        <EmbeddedContainer>
            <Box sx={{
                width: '100%',
                height: '100%',
            }}>
                <MRTDataGridv2
                    columns={columns}
                    data={loads || []}
                    enableColumnActions={false}
                    enableColumnFilters={false}
                    enablePagination={false}
                    enableSorting={false}
                    enableBottomToolbar={false}
                    enableTopToolbar={false}
                    positionActionsColumn='last'
                />
            </Box>

        </EmbeddedContainer>
    )
}

export default EmbeddedLoadTable
